import { useMemo, memo } from "react";
import { Link } from "react-router-dom";
import { artSections } from "../../data/main.data";
import ArrowRight from "../../svg/ArrowRight";

function ArtPage() {
  const artSectionElements = useMemo(() => {
    return artSections.map((sectionData: any, index: any) => {
      return <ArtSectionCard key={index} sectionData={sectionData} />;
    });
  }, []);

  return (
    <div className="w-full text-black text-lg md:text-xl font-light font-boska">
      <div className="w-full flex flex-col md:flex-row justify-start md:justify-center items-center gap-10">
        {artSectionElements}
      </div>
    </div>
  );
}

function ArtSectionCard({ sectionData }: any) {
  const { name, imgUrl } = sectionData;

  return (
    <Link to={`/artSection/${name}`}>
      <div
        style={{ backgroundImage: `url(${imgUrl})` }}
        className="w-full rounded-md shadow-xl bg-no-repeat bg-cover transition-transform duration-1000 ease-in-out hover:cursor-pointer md:hover:scale-[1.03]"
      >
        <img src={imgUrl} alt={name} className="rounded-md w-full invisible" />

        <div className="leading-none flex justify-center items-center gap-2 font-black text-white text-xl font-boska rounded-md w-full h-full bg-black/60 py-5">
          <span>{name}</span>
          <div className="pt-1">
            <ArrowRight />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default memo(ArtPage);
